import React from 'react'
import { Heading, Box, type BoxProps } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface LogoProps extends Omit<BoxProps, 'size'> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  onClick?: () => void
  className?: string
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  onClick,
  className,
  ...boxProps
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const sizeStyles = {
    sm: {
      fontSize: '2xl',
      fontWeight: '600',
    },
    md: {
      fontSize: '3xl',
      fontWeight: '700',
    },
    lg: {
      fontSize: '4xl',
      fontWeight: '800',
    },
    xl: {
      fontSize: '5xl',
      fontWeight: '900',
    },
    '2xl': {
      fontSize: '6xl',
      fontWeight: '900',
    }
  }

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      navigate('/')
    }
  }

  return (
    <Box className={className} {...boxProps}>
      <Heading
        as="h1"
        fontSize={sizeStyles[size].fontSize}
        fontWeight={sizeStyles[size].fontWeight}
        fontFamily="brand"
        cursor="pointer"
        transition="all 0.2s ease"
        _hover={{
          transform: 'translateY(-1px)',
        }}
        _active={{
          transform: 'translateY(0)',
        }}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        aria-label={t('logo.aria_label')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleClick()
          }
        }}
      >
        <Box as="span" color="#17a2b8">live</Box>
        <Box as="span" color="v3.green">wello</Box>
      </Heading>
    </Box>
  )
}

export default Logo